export default {
    meta: {
        title: '拓店宝-合同签约',
    },
};
